import React from "react"
import "../style/toyApi.css"
import{Link} from "react-router-dom"


export default function ToyApi(param) 
{



    return(
        <div className="toy_api_container">
            <header className="toy_api_header">
                <h2 className="toy_api_h2">Welcome To The Toy Api</h2>
                </header>
                
               <div className="subHeader h3"> <h3 >Ther are a few extra end points that give the ability to add delete and edit<span className="subHeader_span"> product's, but to interact with them you will need a user name and password.</span><span className="smaily"><img className="smaily" src="images\smile-wink-regular.svg"/></span></h3></div>
               <button className="backBtn"><Link to="/"  className="backBtnLink">BACK</Link></button>
               
               <div className="get_header h3"> <h3 >Here you will find the end points of the API.<span> All the end point's are in GET</span></h3></div>
                <div className="toy_api_body">
                    <div className="toy_api_left_side">

                        {/* all products */}
                        <div className="toy_api_left_card ">
                            <h3 className="left_card_h3">For example:  https://my-toy-store.herokuapp.com/<br/>prods/</h3>
                        </div>

                        {/* all products */}
                        <div className="toy_api_left_card ">
                            <h3 className="left_card_h3">For example:  https://my-toy-store.herokuapp.com/<br/>prods/page/0</h3>
                        </div>
                        
                        {/* all products */}
                        <div className="toy_api_left_card ">
                            <h3 className="left_card_h3">For example:  https://my-toy-store.herokuapp.com/<br/>prods/page/1?inPage=3</h3>
                        </div>
                        
                        {/* all products */}
                        <div className="toy_api_left_card ">
                            <h3 className="left_card_h3">For example:  https://my-toy-store.herokuapp.com/<br/>prods/countprods</h3>
                        </div>
                        
                        {/* all products */}
                        <div className="toy_api_left_card ">
                            <h3 className="left_card_h3">For example:  https://my-toy-store.herokuapp.com/<br/>prods/cat/console</h3>
                        </div>
                        
                        
                        {/* all products */}
                        <div className="toy_api_left_card ">
                            <h3 className="left_card_h3">For example:  https://my-toy-store.herokuapp.com/<br/>prods/search/?q=switch</h3>
                        </div>
                    </div>
                   
                   
                   {/*  */}
                    <div className="toy_api_rigt_side">

                        {/*  */}
                    <div className="toy_api_rigt_card toy_api_card">
                            <h3 className="left_card_h3">In this end poit you can see all the products</h3>
                        </div>

                              {/*  */}
                    <div className="toy_api_rigt_card toy_api_card">
                            <h3 className="left_card_h3">In this end poit you can divide the products<br/> to pages</h3>
                        </div>
                              
                              
                              {/*  */}
                    <div className="toy_api_rigt_card toy_api_card">
                            <h3 className="left_card_h3">In this end poit you can decide how many<br/> products you want in a page</h3>
                        </div>
                              
                              {/*  */}
                    <div className="toy_api_rigt_card toy_api_card">
                            <h3 className="left_card_h3">In this end poit you can see the number of<br/> products the api has</h3>
                        </div>
                              
                              {/*  */}
                    <div className="toy_api_rigt_card toy_api_card">
                            <h3 className="left_card_h3">In this end poit you can see all the product<br/> in one category</h3>
                        </div>
              
                              {/*  */}
                    <div className="toy_api_rigt_card toy_api_card">
                            <h3 className="left_card_h3">In this end poit you can seach for product by<br/>product name</h3>
                        </div>
                    </div>
                </div>
            
        </div>
    )
  }